import api from "../services/api";

// Currency code -> the symbol shown next to amounts ("USD" -> "$").
// The symbols typed in Currencies are used when known; the browser's own table covers the rest (and everything
// before the list has loaded), and the code itself is the last fallback.
let custom = {};
let started = false;

export function loadCurrencySymbols() {
  if (started) return;
  started = true;
  api.get("/currencies/?page_size=200", { silent: true })
    .then((r) => {
      const rows = Array.isArray(r.data) ? r.data : r.data?.results || [];
      custom = Object.fromEntries(rows.filter((c) => c.code && c.symbol).map((c) => [String(c.code).toUpperCase(), c.symbol]));
    })
    .catch(() => { started = false; });     // no permission or offline: the built-in symbols are used
}

const cache = {};

export function sym(code) {
  const c = String(code || "").trim().toUpperCase();
  if (!c) return "";
  if (custom[c]) return custom[c];
  if (!(c in cache)) {
    try {
      const part = new Intl.NumberFormat("en", { style: "currency", currency: c, currencyDisplay: "narrowSymbol" })
        .formatToParts(0).find((p) => p.type === "currency");
      cache[c] = part ? part.value : c;
    } catch {
      cache[c] = c;
    }
  }
  return cache[c];
}
